import React from 'react'
import Branding from './Branding'
import Hamburger from './buttons/Hamburger'

interface HeaderProps {
  sidebarState: boolean
  sidebarToggleState: () => void
}

const Header: React.FC<HeaderProps> = ({ sidebarToggleState, sidebarState }) => {
  return (
    <header className='header z-40 flex justify-between md:justify-center items-center p-5 h-[90px] md:h-[12vh] w-full bg-cents-grey'>
      <Branding />
      <div>{/* Charity Picklist for agency */}</div>
      <Hamburger toggleState={sidebarToggleState} isOpen={sidebarState}/>
    </header>
  )
}

export default Header